<template>
  <mdb-container class="gp-has-header">
    <div v-if="showMain" class="text-left">
      <data-table :clickHandler="openBounce"
                  :columns="columns"
                  dataSource="/admin/emailBounces"
                  pageTitle="Email Bounces"/>
    </div>
    <div v-if="showBounce">
      <mdb-card class="mb-4">
        <mdb-card-body class="text-left">
          <pre>
            {{ JSON.stringify(currentBounce.rawReport, null, 2) }}
          </pre>
          <mdb-btn @click="cancelShow" icon="minus-circle">Close</mdb-btn>
        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbInput} from 'mdbvue';

export default {
  name: 'email-bounces',
  components: {
    mdbContainer, mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    dataTable
  },
  mounted() {

  },
  data() {
    return {
      rows: [],
      columns: [
        {label: "Date", field: "timestamp"},
        {label: "Email To", field: "email"},
        {label: "Email From", field: "source"},
        {label: "Type", field: "type"},
        {label: "Sub Type", field: "subType"},
        {label: "Subject", field: "subject"},
      ],
      methods: [
        {text: "GET", value: "GET"}
      ],
      currentBounce: null,
      showBounce: false,
      showMain: true,
    }
  },
  methods: {
    cancelShow: function () {
      this.showMain = true
      this.currentBounce = null
      this.showBounce = false
    },
    openBounce: function (row) {
      this.showMain = false
      this.currentBounce = row
      this.showBounce = true
    }

  }

};
</script>
